



import Page from '../PostSales/postsalesuser/aftersale/aftersale.vue'
export default {
  name: 'aftersaleOEM',
  components: { Page },
}
